import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import PlantTest from "@/pages/PlantTest";
import InstallPrompt from "@/components/InstallPrompt";
import { captureDeferredPrompt } from "@/lib/pwa";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="mobile-shell flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#4A6B53] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user && !location.state?.user) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render to handle session_id callback BEFORE protected routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingOrDashboard />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/planttest" element={<PlantTest />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function LandingOrDashboard() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="mobile-shell flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#4A6B53] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

function SWRegistrar() {
  useEffect(() => {
    captureDeferredPrompt();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .catch((e) => console.warn("SW registration failed", e));
    }
  }, []);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SWRegistrar />
        <InstallPrompt />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
